//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import PROJECT_ROLES from '@/constants/project-roles'
import ModalErrorUsers from '@/components/Projects/users/ModalErrorUsers.vue'
import MessageWithoutHeader from '@/components/Shared/MessageWithoutHeader.vue'
import ProjectSupervisorCollaboratorList from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/ProjectSupervisorCollaboratorList.vue'
import ModalSupervisorCollaborator from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/ModalSupervisorCollaborator.vue'
import ModalAddCollaborator from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/collaborator/ModalAddCollaborator.vue'
import ModalAddSupervisor from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/supervisor/ModalAddSupervisor.vue'
import NewProjectsWizardButtons from '@/components/Projects/NewProjectWizardButtons.vue'
import MassiveImportSupervisorModal from './supervisor/MassiveImportSupervisorModal.vue'
import CustomInvitationModal from '~/components/Projects/users/CustomInvitationModal.vue'
import MassiveImportCollaboratorModal from '~/components/Projects/NewProjectSteps/StepSupervisorCollaborator/collaborator/MassiveImportCollaboratorModal.vue'
import MassiveImportInfoCollaboratorModal from '~/components/Projects/NewProjectSteps/StepSupervisorCollaborator/collaborator/MassiveImportInfoCollaboratorModal.vue'
import MassiveImportInfoSupervisorModal from '~/components/Projects/NewProjectSteps/StepSupervisorCollaborator/supervisor/MassiveImportInfoSupervisorModal.vue'

export default {
  name: 'StepSupervisorCollaborator',
  components: {
    Multiselect,
    ModalErrorUsers,
    ProjectSupervisorCollaboratorList,
    ModalSupervisorCollaborator,
    ModalAddCollaborator,
    ModalAddSupervisor,
    CustomInvitationModal,
    MessageWithoutHeader,
    MassiveImportCollaboratorModal,
    MassiveImportInfoCollaboratorModal,
    MassiveImportSupervisorModal,
    MassiveImportInfoSupervisorModal,
    NewProjectsWizardButtons,
  },
  async fetch() {
    this.$store.commit('loading', true)
    await this.getEmployeesInProject()
    this.$store.commit('loading', false)
  },
  data() {
    return {
      employeeTypesList: [
        { value: PROJECT_ROLES.COLLABORATOR, label: 'Colaborador' },
        { value: PROJECT_ROLES.SUPERVISOR, label: 'Supervisor' },
      ],
      employeeType: [],
      isShowCustomMessage: false,
      isShowModalAddUsers: false,
      isShowModalCollaborators: false,
      isShowModalSupervisors: false,
      isShowModalErrorUsers: false,
      isShowModalMassiveImportCollaborator: false,
      isShowModalInfoMassiveImportCollaborator: false,
      isShowModalMassiveImportSupervisor: false,
      isShowModalInfoMassiveImportSupervisor: false,
      term: '',
      textModalErrorUsers: '',
      employees: [],
      employees_in_project: [],
      collaboratorsInfo: [],
      supervisorsInfo: [],
    }
  },
  computed: {
    ...mapGetters({
      getBaseProject: 'project/getBaseProject',
    }),
    employeeTypeFilter() {
      if (!this.employeeType) {
        return null
      }
      return this.employeeType.value
    },
    hasAtLeastOneSupervisorAndOneCollaborator() {
      const supervisors = this.employees_in_project.filter(
        (employee) =>
          employee.projectRole?.employee_type === PROJECT_ROLES.SUPERVISOR
      )
      const collaborators = this.employees_in_project.filter(
        (employee) =>
          employee.projectRole?.employee_type === PROJECT_ROLES.COLLABORATOR
      )
      return supervisors.length > 0 && collaborators.length > 0
    },
  },
  methods: {
    handleBack() {
      this.$emit('back')
    },
    handleContinue() {
      this.$emit('next')
    },
    toggleModalCustomMessage() {
      this.isShowCustomMessage = !this.isShowCustomMessage
    },
    toggleModalAddUsers() {
      this.isShowModalAddUsers = !this.isShowModalAddUsers
    },
    toggleModalCollaborators() {
      this.isShowModalCollaborators = !this.isShowModalCollaborators
    },
    toggleModalSupervisors() {
      this.isShowModalSupervisors = !this.isShowModalSupervisors
    },
    openAddSupervisorModal() {
      this.isShowModalAddUsers = false
      this.isShowModalSupervisors = true
    },
    openAddCollaboratorModal() {
      this.isShowModalAddUsers = false
      this.isShowModalCollaborators = true
    },
    toogleModalErrorUsers() {
      this.isShowModalErrorUsers = !this.isShowModalErrorUsers
    },
    togleMassiveImportCollaboratorModal() {
      this.isShowModalMassiveImportCollaborator = !this
        .isShowModalMassiveImportCollaborator
    },
    toggleModalConfirmRegisterMassiveCollaborators() {
      this.isShowModalInfoMassiveImportCollaborator = !this
        .isShowModalInfoMassiveImportCollaborator
    },
    toggleModalConfirmRegisterMassiveSupervisors() {
      this.isShowModalInfoMassiveImportSupervisor = !this
        .isShowModalInfoMassiveImportSupervisor
    },
    toggleMassiveImportSupervisorModal() {
      this.isShowModalMassiveImportSupervisor = !this
        .isShowModalMassiveImportSupervisor
    },
    async finishSaveCollaborator() {
      await this.getEmployeesInProject()
      this.isShowModalCollaborators = false
    },
    async finishSaveSupervisor() {
      this.isShowModalSupervisors = false
      await this.getEmployeesInProject()
    },
    async finishMassiveCollaborator() {
      this.toggleModalConfirmRegisterMassiveCollaborators()
      await this.getEmployeesInProject()
    },
    async finishMassiveSupervisor() {
      this.toggleModalConfirmRegisterMassiveSupervisors()
      await this.getEmployeesInProject()
    },
    async refreshEmployeesInProject() {
      await this.getEmployeesInProject()
    },
    handleUserWithError(message) {
      this.textModalErrorUsers = message
      this.isShowModalErrorUsers = true
    },
    async getEmployees(companyId) {
      const employees = await this.$repository.user.findWithProjectRolesByCompany(
        {
          company: companyId,
        }
      )

      return employees.map((employee) => {
        const projectRole = employee.project_roles?.find(
          (projectRole) =>
            projectRole.project === this.getBaseProject.id &&
            projectRole.deleted_at === null
        )
        return {
          ...employee,
          projectRole: projectRole || null,
        }
      })
    },
    async getEmployeesInProject() {
      this.$store.commit('loading', true)
      this.employees = await this.getEmployees(this.$strapi.user.company.id)
      const tempUsers = await this.$repository.user.findWithProjectRolesByProject(
        {
          project: this.getBaseProject.id,
        }
      )

      const employeeIds = tempUsers.map((employee) => employee.id)

      const tempInvitations = await this.$repository.invitation.findAll({
        _where: {
          user: employeeIds,
        },
      })

      this.employees_in_project = tempUsers.map((employee) => {
        const invitation = tempInvitations.find(
          (invitation) => invitation.user === employee.id
        )
        const projectRole = employee.project_roles?.find(
          (projectRole) =>
            projectRole.project === this.getBaseProject.id &&
            projectRole.deleted_at === null
        )
        return {
          ...employee,
          invitation: invitation || null,
          projectRole: projectRole || null,
        }
      })
      this.$store.commit('loading', false)
    },
    async updateSupervisorCollaborator(selectedOption) {
      await this.$repository.projectRoles.update(selectedOption.id, {
        employee_type: selectedOption.employee_type,
      })
      if (selectedOption.employee_type === PROJECT_ROLES.COLLABORATOR) {
        await this.$repository.user.update(selectedOption.user, {
          project: selectedOption.project,
        })
        await this.$repository.supervisorAssignments.deleteBySupervisorAndProject(
          selectedOption.user,
          selectedOption.project
        )
      } else {
        await this.$repository.user.update(selectedOption.user, {
          project: null,
        })
      }
      this.getEmployeesInProject()
    },
    handleMassiveCollaboratorModel() {
      this.toggleModalCollaborators()
      this.togleMassiveImportCollaboratorModal()
    },
    handleMassiveSupervisorModal() {
      this.toggleModalSupervisors()
      this.toggleMassiveImportSupervisorModal()
    },
    sendCollaboratorsDetails(collaborators) {
      this.collaboratorsInfo = collaborators
      this.togleMassiveImportCollaboratorModal()
      this.toggleModalConfirmRegisterMassiveCollaborators()
    },
    sendSupervisorsDetails(supervisors) {
      this.supervisorsInfo = supervisors
      this.toggleMassiveImportSupervisorModal()
      this.toggleModalConfirmRegisterMassiveSupervisors()
    },
  },
}
